export const COLORS = {
  RED: "#C73B3B",
  BLUE: "#16496E",
}
